const config = () => {
  const environments = {
    development: {
      environment: "development",
      apiServer: "/",
      spotlightApiServer: "https://api.dev.spotlightnews.us",
      apiEventServer: "https://event-api.dev.spotlightnews.us",
      sentryDSN: null,
      version: "development",
      tokenKey: "dev-my.spotlightnews.us-token",
      tokenKeyDelete: "dev-my.spotlightnews.us-delete-account-token",
      // Dev-only: enables the "Dev Login" token field on the Sign In card so a
      // developer can authenticate by pasting a dev JWT directly (or a user_id),
      // skipping the Spotlight Lobby redirect. Enabled on local dev and on the
      // Cloud Run preview host below, but NEVER on the public my.spotlightnews.us
      // (or staging) host, so it can't render in real production.
      allowDevLogin: true,
    },
    staging: {
      environment: "staging",
      apiServer: "/",
      spotlightApiServer: "https://api.stg.spotlightnews.us",
      apiEventServer: "https://event-api.stg.spotlightnews.us",
      sentryDSN: "https://f2d17adc064f44928221ff18ba2caceb@sentry.io/1536597",
      version: `${process.env.REACT_APP_RELEASE_VERSION}+${process.env.REACT_APP_COMMIT_SHA1_SHORT}`,
      tokenKey: "stg-my.spotlightnews.us-token",
    },
    production: {
      environment: "production",
      apiServer: "/",
      spotlightApiServer: "https://api.spotlightnews.us",
      apiEventServer: "https://event-api.spotlightnews.us",
      sentryDSN: "https://f2d17adc064f44928221ff18ba2caceb@sentry.io/1536597",
      version: process.env.REACT_APP_RELEASE_VERSION,
      tokenKey: "my.spotlightnews.us-token",
    },
  };

  const { hostname, origin, pathname } = window.location;
  const isLocal = hostname === "localhost" || hostname === "127.0.0.1";
  const isExplicitNonProd =
    hostname.includes("dev") ||
    hostname.includes("staging") ||
    hostname.includes("stg") ||
    hostname.includes("sandbox");
  const isSpotlightProductionHost =
    hostname === "worldcup.spotlightnews.us" ||
    (hostname.endsWith(".spotlightnews.us") && !isExplicitNonProd);
  const isKnownWorldCupRunApp =
    hostname === "worldcup-webapp-316025388486.us-central1.run.app";
  const isWorldCupHost =
    hostname === "worldcup.spotlightnews.us" ||
    hostname.startsWith("worldcup-webapp-") ||
    pathname.startsWith("/worldcup");
  const withRule = (environment, matchedConfigRule, overrides = {}) => ({
    ...environment,
    ...overrides,
    matchedConfigRule,
  });

  if (isLocal || hostname === "") {
    return withRule(environments.development, "local-development");
  }

  if (isKnownWorldCupRunApp) {
    // This raw Cloud Run URL has leaked into production webviews, so it must
    // behave like production if opened.
    return withRule(environments.production, "production-worldcup-run-app", {
      defaultContestId: 45,
      allowDevLogin: false,
    });
  }

  if (isSpotlightProductionHost) {
    return withRule(environments.production, "production-spotlightnews-host", {
      ...(isWorldCupHost ? { defaultContestId: 45 } : {}),
      allowDevLogin: false,
    });
  }

  if (isExplicitNonProd) {
    const isStagingHost =
      origin === "https://my.stg.spotlightnews.us" ||
      hostname === "stg.spotlightnews.us" ||
      hostname.endsWith(".stg.spotlightnews.us") ||
      hostname.includes("staging");
    return withRule(
      isStagingHost ? environments.staging : environments.development,
      isStagingHost ? "staging-explicit-non-prod" : "development-explicit-non-prod",
      {
        allowDevLogin: true,
      },
    );
  }

  // Unknown public hosts must fail closed: production API, no dev login.
  return withRule(environments.production, "production-safe-unknown-public-host", {
    ...(isWorldCupHost ? { defaultContestId: 45 } : {}),
    allowDevLogin: false,
  });
};

export default config();
